import { Activity, PaginatedResponse } from 'model';
import { parse } from 'query-string';
import { combineEpics } from 'redux-observable';
import { Epic } from 'redux/modules/types';
import { catchError, filter, mergeMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';
import { ACTIVITY_PER_PAGE } from 'utils/config';
import { getActivityBellItems } from './actions';

export const getActivityBellItemsEpic: Epic = (action$, _, { request }) =>
  action$.pipe(
    filter(isActionOf(getActivityBellItems.request)),
    mergeMap(
      ({ payload: { search = '', page, pageSize = ACTIVITY_PER_PAGE } }) =>
        request<PaginatedResponse<Activity>>({
          path: 'activity/bell',
          params: {
            ...parse(search),
            page,
            pageSize,
          },
        }).pipe(
          mergeMap((response) => [getActivityBellItems.success(response)]),
          catchError(() => [getActivityBellItems.failure()]),
        ),
    ),
  );

export default combineEpics(getActivityBellItemsEpic);
